export default __webpack_public_path__ + "static/media/2025-Annual-PREA-Report.b5200726.pdf";